// feature-harden.md 6.4: user-entered amounts must be validated as strict
// decimal strings, not run through parseFloat — parseFloat is far too
// lenient for a wallet ("10abc" -> 10, "  5" -> 5, "1e3" -> 1000,
// "Infinity" -> Infinity), silently accepting input the user didn't
// actually type as a clean number. Full BigInt base-unit conversion still
// waits on 6.0 (no real signTransfer call site to convert units at yet) —
// this only keeps amounts as exact decimal strings through validation and
// display, ahead of that eventual conversion.
const DECIMAL_RE = /^\d+(\.\d+)?$/;

export function isValidDecimalString(s) {
  return typeof s === 'string' && DECIMAL_RE.test(s.trim());
}

export function isPositiveDecimalString(s) {
  return isValidDecimalString(s) && Number(s.trim()) > 0;
}
